import { Component, ViewChild, SimpleChange, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

import { MiniTracker } from 'huddyapi';

import { NumberKeyboard } from '../../number-keyboard/numberKeyboard';

import { Subject, Subscription } from 'rxjs';


@Component({
	selector: 'evidence-widget',
	templateUrl: 'evidence-widget.html',
	styleUrls: ['./evidence-widget.scss'],
	inputs: ['data', 'caller',  'clearSubject$' , 'yesterdayLoaded', 'yesterdayValue']
})
export class EvidenceWidget  {
	@Input() keyboard: NumberKeyboard;
	@Input() focusSet: boolean = false;
	@Input() clearSubject$ : Subject<boolean>;
	@Input() yesterdayValue : number;
	@Input() data: MiniTracker;
    clearSub : Subscription;
	
	caller: any;
	isBlinking: boolean;
	blinkingTimeout: any;
	@ViewChild('textbox', { static: true }) textBox: ElementRef;
	onChar: (key: string) => any;
	onBackspace: () => any;
	onSubmit: () => any;
	yesterdayLoaded : boolean;

	constructor() {
		this.isBlinking = true;

	}



  setKeyboardFunctions() {
    this.keyboard.onChar = this.onChar;
		this.keyboard.onBackspace = this.onBackspace;
		this.keyboard.onSubmit = this.onSubmit;
  }




	stopBlinking() {
		if(this.blinkingTimeout) {
			clearTimeout(this.blinkingTimeout);
		}
		this.isBlinking = false;
		this.blinkingTimeout = setTimeout(() => {
			clearTimeout(this.blinkingTimeout);
			this.isBlinking = true;
		}, 500);
	}

	getInputClasses() {
		let ret = 'input';
		if(this.focusSet)
			ret += ' active';
		if(this.isBlinking)
			ret += ' blinking';
		return ret;
	}

	focus() {
    console.log( 'EvidenceWidget','focus enter', this.keyboard) ;
    this.textBox.nativeElement.focus();
    console.log( 'EvidenceWidget','focus exit') ;
	}

	ngAfterViewInit() {

	}

  getYesterday() {
    return this.data.yesterdayValue;
  }

    getYesterdayText() : string {
       return 'yesterday';
    }
}
